import { CUIDrawerBody, CUIDrawerCloseButton, CUIDrawerContent } from 'connect-dot-com-ui-components/Components/CUIDrawer/CUIDrawer';
import CUILink from 'connect-dot-com-ui-components/Components/CUILink/CUILink';
import CUIRouterLink from 'connect-dot-com-ui-components/Components/CUIRouterLink/CUIRouterLink';
import { CUIStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import LoginSignupButtons from '../AuthButtons/LoginSignupButtons';
import { trackInteraction } from '../../utils/usageTracker';
import CUIConnectLogo from 'connect-dot-com-ui-components/Components/CUIConnectLogo/CUIConnectLogo';
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileNavDrawerContent = ({
  navLinks,
  onClose,
  getActiveLinkColor,
  trackHeaderClick
}) => {
  return /*#__PURE__*/_jsx(CUIDrawerContent, {
    children: /*#__PURE__*/_jsxs(CUIBox, {
      padding: "20px",
      children: [/*#__PURE__*/_jsx(CUIDrawerCloseButton, {
        size: "lg",
        variant: "ghost",
        color: "CARNABY.regular",
        onClick: onClose
      }), /*#__PURE__*/_jsx(CUIRouterLink, {
        to: "/",
        onClick: () => trackInteraction('click header nav logo'),
        maxW: {
          base: '100%',
          sm: '180px'
        },
        children: /*#__PURE__*/_jsx(CUIConnectLogo, {
          alt: I18n.text('app.homepage.header.logoAlt'),
          width: "150px"
        })
      }), /*#__PURE__*/_jsx(CUIDrawerBody, {
        children: /*#__PURE__*/_jsxs(CUIStack, {
          as: "nav",
          role: "navigation",
          align: "center",
          direction: "column",
          px: 4,
          gap: 4,
          fontWeight: "500",
          children: [/*#__PURE__*/_jsx(CUIRouterLink, {
            color: getActiveLinkColor('/'),
            to: "/",
            onClick: () => trackHeaderClick('home'),
            "data-test-id": "nav-home-link",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "connect.marketingSite.header.nav.home"
            })
          }), navLinks.map(link => /*#__PURE__*/_jsx(CUILink, {
            href: link.path,
            color: getActiveLinkColor(link.path),
            onClick: () => trackHeaderClick(link.name),
            "data-test-id": link.dataTestId,
            children: link.component
          }, link.name)), /*#__PURE__*/_jsx(LoginSignupButtons, {
            direction: "column",
            gap: 4,
            width: "100%",
            padding: "12px 0",
            margin: "10px 0"
          })]
        })
      })]
    })
  });
};
export default MobileNavDrawerContent;